import OrgChooser from "./components/org-selector/org-selector.component";

import { FetchTenantIdFromCookie, FetchTenantNameFromCookie } from "./components/services/cookie.service";
function App() {

    return <OrgChooser OrgTenantId={FetchTenantIdFromCookie()} OrgName={FetchTenantNameFromCookie()} />
}

export default App